import { render } from "./ChatReply.vue?vue&type=template&id=49b708ce&scoped=true"
import script from "./ChatReply.vue?vue&type=script&lang=js"
export * from "./ChatReply.vue?vue&type=script&lang=js"

import "./ChatReply.vue?vue&type=style&index=0&id=49b708ce&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49b708ce"]])

export default __exports__